<template>
  <div class="client-bids min-vh-100">
    <div class="container-fluid client">
      <div class="clientWrap">
        <div class="row">
          <div class="col-md-12 py-4 text-left">
            <div class="d-flex justify-content-between align-items-center">
              <h1>Activity Stats</h1>
               <button
                class="btn btn-icn ms-auto"
                :disabled="!logs.length"
                @click="exportActivity()"
                v-if="isAdmin"
              >
                <i class="fa fa-download"></i> Export
              </button>
            </div>
          </div>
        </div>
        <div class="row">
         <div class="col-md-12">
        <div class="dark-filter w-100 p-1 mb-2 d-inline-block">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="ml-3 m-0">Filters</h5>
            <span class="btn btn-link" @click="showFilters = !showFilters">
              <i
                class="fa"
                v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']"
              ></i>
              {{ showFilters ? 'Hide' : 'Show' }} Filters
            </span>
          </div>
          <div class="row p-4" v-if="showFilters">
            <div class="col-lg-12">
              <form class="row">
                 <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">From</label>
                      <datepicker v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">To</label>
                      <datepicker v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                   <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">User</label>
                      <!-- <select class="form-control" v-model="searchTerm">
                        <option value="" disabled selected>Select User</option>
                        <option v-for="client in clients" :key="client.firstName" :value="client.firstName + ' ' + client.lastName">
                          {{ client.firstName }} {{ client.lastName }}
                        </option>
                      </select> -->
                      <!-- <multiselect
                          v-model="selectedClient"
                          placeholder="Select"
                          :options="clients"
                          :multiple="false"
                          label="clientFullName"
                          @input="onClientSelect"
                          track-by="id"
                        ></multiselect> -->

                      <input type="text" class="form-control" v-model="searchTerm" placeholder="Search by Name">
                  </div>
                <div class="col-md-6 col-lg-3 mt-1">
                  <button
                    @click="clearFilter()"
                    type="button"
                    class="btn btn-secondary rounded mt-4"
                  >
                    Clear
                  </button>
                  <button
                    @click="searchLog()"
                    type="button"
                    class="btn btn-primary rounded mt-4"
                  >
                    Filter
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        </div>
      </div>
        <div class="row">
          <div class="col-md-12">
            <div class="history filter-list">
              <div class="table-responsive p-0">
                <div class="loader" v-if="loading"></div>

                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col" class="text-left">User</th>
                      <th scope="col" class="text-center">Total Logins</th>
                      <th scope="col" class="text-center">Active Days</th>
                      <th scope="col" class="text-left">Last Login Date</th>
                    </tr>
                  </thead>
                  <tbody class="list no-cursor">
                    <tr v-if="logs.length == 0 && !loading">
                      <td>
                        <p class="nodata text-white">No data available</p>
                      </td>
                    </tr>
                    <tr v-for="data in logs" :key="data.id">
                      <td  class="text-left">{{ data.firstName }} {{ data.lastName }}</td>
                      <td  class="text-center">{{ data.loginCount }}</td>
                      <td  class="text-center">{{ data.uniqueLoginDays }}</td>
                      <td class="text-left">
                        {{
                          data.lastLogin
                            ? moment(data.lastLogin).format(
                                'MMMM DD YYYY, h:mm:ss a'
                              )
                            : ''
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex align-items-center mt-4 position-relative">
                <div>
                  <b-pagination
                    class="mt-4"
                    :total-rows="totalRows"
                    v-model="currentPage"
                    :per-page="perPage"
                    @input="getStats(currentPage)"
                  ></b-pagination>
                  </div>
                  <div class="total-records-client ml-auto">
                    <span>Total Records : {{ totalRows }}</span>
                  </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'
import authService from '@/authService'
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'imsCusipComponent',
  components: {
    Datepicker
  },
  data () {
    return {
      accessToken: null,
      loading: false,
      currentPage: 1,
      perPage: 25,
      searchTerm: '',
      totalRows: 0,
      sortColumn: '',
      sortOrder: 'ASC',
      logs: [],
      moduleName: '',
      showFilters: false,
      alertType: '',
      fromDate: '',
      toDate: '',
      isAdmin: false,
      isRep: false,
      clients: [],
      selectedClient: null,


      
    }
  },
  methods: {
  exportActivity() {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      var fDate = this.fromDate
        ? this.moment(this.fromDate).utc().format("YYYY-MM-DD HH:mm:ss")
        : ''
      var tDate = this.toDate
        ? this.moment(this.toDate).add(1,'days').utc().format('YYYY-MM-DD HH:mm:ss')
        : ''  
      // if(this.selectedClient){
      //   this.searchTerm = this.selectedClient.firstName + ' ' + this.selectedClient.lastName
      // } else {
      //   this.searchTerm = ''
      // }
      let data = {"cognitoSub":authService.getUser().cognitoSub,"fromDate":fDate,"toDate":tDate,"search":this.searchTerm}
      this.$http
        .post(
          config.baseUrlAutoBidder +
            '/user/loginLog-exceldownload',data,auth
        )
        .then(result => {
          window.open(result.data, '_blank');
          // const url = window.URL.createObjectURL(new Blob([result.data]));
          // const link = document.createElement('a');
          // link.href = url;
          // link.setAttribute('download', 'activity_stats.csv');
          // document.body.appendChild(link);
          // link.click();
        })
        .catch(e => {
          console.log(e);
        });
    },
    getClients () {

      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let url =
          config.baseUrlBidSide +
          '/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Client'
      
      this.$http
        .get(url, auth)
        .then(result => {
          this.clients = result.data.content.map(user => {
            return {
              ...user,
              clientFullName: user.firstName + ' ' + user.lastName
            }
          })
    
        })
        .catch(e => {
          console.log(e)
    
        })
    },
    clearFilter () {
      this.fromDate = this.moment().format("MM-DD-YYYY");
      this.toDate = this.moment().format("MM-DD-YYYY");
      this.searchTerm = '';
      this.selectedClient = null;
      this.currentPage = 1
      this.getStats()
    },
    searchLog () {
      this.currentPage = 1
      this.getStats()
    },
    getStats () {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      var fDate = this.fromDate
        ? this.moment(this.fromDate).utc().format("YYYY-MM-DD HH:mm:ss")
        : ''
      var tDate = this.toDate
        ? this.moment(this.toDate).add(1,'days').utc().format('YYYY-MM-DD HH:mm:ss') 
        : ''
        // user/loginLog?page=0&size=10&fromDate=2026-02-01 00:00:00&toDate=2026-02-04 23:59:59
        if(this.selectedClient){
          this.searchTerm = this.selectedClient.firstName + ' ' + this.selectedClient.lastName
        } else {
          this.searchTerm = ''
        }
      this.$http
        .get(
          config.baseUrlAutoBidder +
            '/user/loginLog?page=' +
           (this.currentPage - 1) +
            '&size=' +
            this.perPage +
            '&fromDate=' +
            fDate +
            '&toDate=' +
            tDate +
            '&search=' +
            this.searchTerm,
          auth
        )
        .then(result => {
          this.logs = result.data.content
          this.totalRows = result.data.totalElements
          this.loading = false
        })
        .catch(e => {
          console.log(e)
          this.loading = false
        })
    }
  },
  mounted () {
    this.fromDate = this.moment().format("MM-DD-YYYY");
    this.toDate = this.moment().format("MM-DD-YYYY");
      this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Rep')   ? this.isRep  = true : this.isRep  = false;
          // this.fromDate = this.moment().format("MM-DD-YYYY HH:mm:ss");
          // this.toDate = this.moment().add(1,'days').format("MM-DD-YYYY HH:mm:ss");
          this.getStats()
          this.getClients()


        }
      });
  }
}
</script>
<style scoped>
.loader {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: #4c6fff; /* soft neon blue */
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
  margin: auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>


